import { useState } from 'react';
import { SidebarSection } from '../../pages/editTrip/editTripSidebar';

interface UseEditSidebarReturn {
  activeSection: SidebarSection;
  open: (section: SidebarSection) => void;
  close: () => void;
}

/**
 * Hook to manage sidebar state.
 * Platform-agnostic: Pure state management, works in React Native.
 *
 * @returns Sidebar state and control functions
 */
export const useEditSidebar = (): UseEditSidebarReturn => {
  const [activeSection, setActiveSection] = useState<SidebarSection>(null);

  const open = (section: SidebarSection) => {
    setActiveSection(section);
  };

  const close = () => {
    setActiveSection(null);
  };

  return {
    activeSection,
    open,
    close,
  };
};
